module.exports = __webpack_public_path__ + "media/anastomosis.b4759d92.wav";